module.exports = __webpack_public_path__ + "img/no-car.4c3ddecc.png";